/**
 * GoBox FAQ - JavaScript Functionality
 * Accordion functionality for FAQ items
 */

(function() {
  'use strict';

  function init() {
    setupFAQ();
  }

  /**
   * FAQ Accordion
   */
  function setupFAQ() {
    const faqItems = document.querySelectorAll('.faq-item');
    
    faqItems.forEach((item) => {
      const toggle = item.querySelector('.faq-toggle');
      const answer = item.querySelector('.faq-answer');
      const icon = item.querySelector('.faq-icon');

      if (!toggle || !answer) return;

      toggle.addEventListener('click', function() {
        const isOpen = item.classList.contains('open');
        const sectionId = item.dataset.section;

        // Close all FAQs in this section
        if (sectionId) {
          const sectionFaqs = document.querySelectorAll(`.faq-item[data-section="${sectionId}"]`);
          sectionFaqs.forEach(faq => {
            faq.classList.remove('open');
            const faqAnswer = faq.querySelector('.faq-answer');
            const faqIcon = faq.querySelector('.faq-icon');
            const faqToggle = faq.querySelector('.faq-toggle');
            if (faqAnswer) faqAnswer.classList.remove('open');
            if (faqIcon) faqIcon.classList.remove('rotate-180');
            if (faqToggle) faqToggle.setAttribute('aria-expanded', 'false');
          });
        }

        // Toggle clicked FAQ
        if (!isOpen) {
          item.classList.add('open');
          answer.classList.add('open');
          if (icon) icon.classList.add('rotate-180');
          toggle.setAttribute('aria-expanded', 'true');
        } else {
          // If it was open, close it
          item.classList.remove('open');
          answer.classList.remove('open');
          if (icon) icon.classList.remove('rotate-180');
          toggle.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
